export const retroFix = (str) => {
  switch (str) {
    case "Uluru Kata-Tjuta National Park":
      return "Ulu<u>r</u>u Kata-Tju<u>t</u>a National Park";
    case "Katiti Petermann IPA":
      return "Ka<u>t</u>i<u>t</u>i–Petermann IPA";
    default:
      return str;
  }
};
export const cleanString = (str) => str && str.replace(/<\/?[^>]+(>|$)/g, "");

export const allEqual = (arr) => arr && arr.every((val) => val === arr[0]);
/*
export const getAddress = (latlng) => {
  return new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === "OK") {
        resolve(results[0].geometry.location);
      } else {
        reject(status);
      }
    });
  });
};
*/

/*
export const getDistance = (lat1, lng1, lat2, lon2, unit) => {
  var radlat1 = (Math.PI * lat1) / 180;
  var radlat2 = (Math.PI * lat2) / 180;
  var theta = lng1 - lon2;
  var radtheta = (Math.PI * theta) / 180;
  var dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  if (unit === "K") {
    dist = dist * 1.609344;
  }
  if (unit === "N") {
    dist = dist * 0.8684;
  }
  return dist;
};
*/

//calculates distance between two points in km's
// const calcDistance = (p1, p2) => {
//   return (
//     window.google.maps.geometry.spherical.computeDistanceBetween(p1, p2) / 1000
//   ).toFixed(2);
// };

export const getDistanceByKm = (p1, p2) => {
  // const p1 = p11.toJSON();
  // const p2 = p22.toJSON();
  const R = 6371; // Radius of the Earth in km
  const dLat = ((p2.lat - p1.lat) * Math.PI) / 180;
  const dLon = ((p2.lng - p1.lng) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((p1.lat * Math.PI) / 180) *
      Math.cos((p2.lat * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  // console.log((window.google.maps.geometry.spherical.computeDistanceBetween(p11, p22) / 1000).toFixed(2),1);
  // console.log(R * c,2);
  return R * c;
};

/*
  export const getDuplicates = (arr) =>
    Object.values(
      arr.reduce((c, v) => {
        let k = v.lat + "-" + v.lng;
        c[k] = c[k] || [];
        c[k].push(v);
        return c;
      }, {})
    ).reduce((c, v) => (v.length > 1 ? c.concat(v) : c), []);
  */

export class DefaultRenderer {
  constructor(props) {
    this.color = props.color;
    this.zIndex = props.zIndex;
    this.icon = props.icon;
    this.size = props.size;
  }

  render({ count, position }, stats) {
    const svg = this.icon
      ? window.btoa(this.icon)
      : window.btoa(`
      <svg fill="${this.color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity=".6" r="70" />
        <circle cx="120" cy="120" opacity=".3" r="90" />
        <circle cx="120" cy="120" opacity=".2" r="110" />
      </svg>`);
    // create marker using svg icon
    return new window.google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: this.size
          ? new window.google.maps.Size(this.size, this.size)
          : new window.google.maps.Size(45, 45),
      },
      // label: {
      //   text: String(count),
      //   color: "rgba(0,0,0,0.9)",
      //   fontSize: "12px",
      // },
      title: `Group of ${count} markers`,
      // adjust zIndex to be above other markers
      zIndex: this.zIndex
        ? this.zIndex
        : Number(window.google.maps.Marker.MAX_ZINDEX) + count,
      // optimized: false,
    });
  }
}

export const Spinner = () => (
  <div className="gm-loader">
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 100 100"
      xmlSpace="preserve"
    >
      <path
        fill="#ffffff"
        d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="2s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
      <path
        fill="#ffffff"
        d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 50 50"
          to="-360 50 50"
          repeatCount="indefinite"
        />
      </path>
      <path
        fill="#ffffff"
        d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
L82,35.7z"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="2s"
          from="0 50 50"
          to="360 50 50"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  </div>
);

export const closeWindowHandler = (layers, l) => {
  for (const lay in layers) {
    if (!layers[lay].group.includes("g0")) {
      if (
        l !== undefined &&
        layers[lay].group === layers[l].group &&
        layers[lay].hasOwnProperty("data")
      ) {
        for (const c in layers[l].data) {
          if (layers[lay].data[c]?.window) {
            layers[lay].data[c].window.close();
          }
        }
        if (layers[lay]?.windows) {
          layers[lay].windows.close();
          delete layers[lay].windows;
        }
      }

      if (l === undefined) {
        if (layers[lay].hasOwnProperty("data")) {
          for (const c in layers[lay]?.data) {
            if (layers[lay].data[c]?.window) {
              layers[lay].data[c].window.close();
            }
          }
          if (layers[lay]?.windows) {
            layers[lay].windows.close();
            delete layers[lay].windows;
          }
        }
      }

      if (
        layers[lay].hasOwnProperty("markers") &&
        layers[lay].markers.hasOwnProperty("windows")
      ) {
        layers[lay].markers.windows.close();
        delete layers[lay].markers.windows;
      }
      if (
        layers[lay].hasOwnProperty("markers") &&
        layers[lay].markers.hasOwnProperty("marker")
      ) {
        layers[lay].markers.marker.setMap(null);
        delete layers[lay].markers.marker;
      }
    }
  }
};
